import { render, staticRenderFns } from "./DasherCoinBalanceReport.vue?vue&type=template&id=7bd87148&scoped=true"
import script from "./DasherCoinBalanceReport.vue?vue&type=script&lang=js"
export * from "./DasherCoinBalanceReport.vue?vue&type=script&lang=js"
import style0 from "./DasherCoinBalanceReport.vue?vue&type=style&index=0&id=7bd87148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd87148",
  null
  
)

export default component.exports